<div>
  <fieldset class="form-group">
    <div [class.disabled]="disabled" class="custom-control custom-radio">
      <input class="custom-control-input"
             type="radio"
             [ngModel]="model"
             (ngModelChange)="onModelChange($event)"
             [name]="name"
             [value]="value"
             [attr.id]="buildChildId()"
             [attr.disabled]="disabled">
      <label class="custom-control-label" [attr.for]="buildChildId()">
        <span class="inner-label">{{label}}</span>
      </label>
    </div>
  </fieldset>
</div>




// WEBPACK FOOTER //
// ./src/app/core/achoo-radio-button/achoo-radio-button.component.html